/* ══════════════════════════════════════════
   Wegzeichen — nur referenziert, nie nachgezeichnet
   ──────────────────────────────────────────
   Die 27 Zeichen haben EINE Quelle: WZ.defs in wegzeichen.js. Die Datei
   liegt als public/dpsg/wegzeichen.js und wird in index.html geladen; sie
   legt beim Start ein <symbol>-Sprite ins Dokument. Hier wird nur darauf
   verwiesen — ein korrigierter Pfad dort wirkt damit an jeder Stelle.

   „Niemals ein Zeichen irgendwo einzeln nachzeichnen."
   (DESIGN-SYSTEM.md §5)

   Die 27 Namen stehen ebenfalls dort. Verwendet werden hier:
     lager        — Lagerplatz, für „keine Veranstaltung"
     folgt-weg    — Wegweiser, für „keine Ergebnisse"
     nachricht    — Botschaft, für „keine Anmeldung gefunden"
   ══════════════════════════════════════════ */

export function Wegzeichen({ sign, className = 'wz', ...rest }) {
  return (
    <svg className={className} viewBox="0 0 60 60" aria-hidden="true" {...rest}>
      <use href={`#wz-${sign}`} />
    </svg>
  );
}

/* Die gestreute Deko hinter Login und Leerzuständen. Die Zeichen liegen
   prozentual, damit sie mitwachsen, und sind für Vorlesesoftware
   unsichtbar (aria-hidden am SVG, pointer-events aus in chalk.css).

   Die Positionen sind fest, nicht zufällig: bei jedem Rendern neu zu
   streuen ließe die Zeichen bei jedem Tastendruck im Formular springen. */
/* Größer, mehr und weiter außen als vorher: die Mitte gehört dem Formular,
   die Zeichen stehen am Rand und tragen deutlich leiser (Deckkraft steht in
   chalk.css). `verzug` staffelt das Einzeichnen — die Zeichen erscheinen
   nacheinander, nicht alle auf einmal. `dauer` und `hub` variieren Länge und
   Höhe des Schwebens: gleiche Werte überall ließen sie im Gleichschritt
   wippen, und das sieht nach Maschine aus statt nach Papier. */
const SCATTER = [
  { sign: 'lager',        top: '6%',  left: '4%',  size: 190, rotate: -12, verzug: 200,  dauer: 11, hub: 18 },
  { sign: 'folgt-weg',    top: '58%', left: '8%',  size: 155, rotate: 8,   verzug: 900,  dauer: 9,  hub: 12 },
  { sign: 'spielbeginn',  top: '12%', left: '80%', size: 175, rotate: 14,  verzug: 550,  dauer: 13, hub: 22 },
  { sign: 'trinkwasser',  top: '70%', left: '82%', size: 140, rotate: -7,  verzug: 1250, dauer: 10, hub: 14 },
  { sign: 'naehe',        top: '40%', left: '92%', size: 120, rotate: 5,   verzug: 1600, dauer: 12, hub: 9  },
  { sign: 'versammeln',   top: '84%', left: '38%', size: 130, rotate: -5,  verzug: 1950, dauer: 14, hub: 16 },
  { sign: 'beginn-spur',  top: '4%',  left: '46%', size: 115, rotate: 10,  verzug: 2300, dauer: 8,  hub: 11 },
  { sign: 'lagerplatz',   top: '30%', left: '18%', size: 100, rotate: -16, verzug: 2650, dauer: 15, hub: 20 },
  { sign: 'entfernung',   top: '88%', left: '66%', size: 108, rotate: 6,   verzug: 3000, dauer: 10, hub: 13 },
  { sign: 'nachricht',    top: '22%', left: '62%', size: 92,  rotate: -9,  verzug: 3350, dauer: 16, hub: 24 },
];

export function DoodleLayer() {
  return (
    <div className="dood-layer" aria-hidden="true">
      {SCATTER.map((m) => (
        <Wegzeichen
          key={m.sign}
          sign={m.sign}
          className="wz dood-motif"
          style={{
            top: m.top,
            left: m.left,
            width: m.size,
            height: m.size,
            /* Die Drehung steht als Variable und nicht als transform: das
               Schweben ist selbst ein transform und würde sie sonst
               überschreiben. Die Keyframes setzen beides zusammen. */
            '--wz-dreh': `${m.rotate}deg`,
            '--wz-verzug': `${m.verzug}ms`,
            '--wz-dauer': `${m.dauer}s`,
            '--wz-hub': `${m.hub}px`,
          }}
        />
      ))}
    </div>
  );
}
